import { Builder } from '@builder.io/react';
import { BUILDER_DIVIDER_NAMES } from '../BuilderComponentsName';
import HeroWithImageAndLinkOnly from '../components/hero/HeroWithImageAndLinkOnly';

Builder.registerComponent(HeroWithImageAndLinkOnly, {
    name: BUILDER_DIVIDER_NAMES.HeroWithImageAndLinkOnly,
});
